import { FC } from 'react'
import classNames from 'classnames'
import styles from './TitleSection.module.scss'
import { MobileView } from 'features/producers-overview/types'
import { TitleSectionProps as Props } from './types'

export const TitleSection: FC<Props> = ({ mobileView, withBanner, children }) => {
  return (
    <section
      className={classNames(
        styles.title,
        { [styles['map-displayed']]: mobileView === MobileView.MAP },
        { [styles['with-banner']]: withBanner }
      )}
    >
      <div className={classNames(styles.container, 'container', 'is-flex-row', 'is-flex-spread', 'is-flex-centered')}>{children}</div>
    </section>
  )
}

export default TitleSection
